/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * @client Inelectro
 * @project webapp-scan
 * @file src\app\framework\ScanMode.ts
 * @copyright 2018 Artionet Web Agency
 */

export enum ScanMode_e {
    NONE,
    LOCATION_FROM_STOCK,
    LOCATION_BETWEEN_EMPLOYEES,
    RETURN_TOOLS
}



// WEBPACK FOOTER //
// ./src/app/framework/ScanMode.ts